import React from "react";

import FieldWithApply from '../utility/FieldWithApply';

export default function CartSpecialOfferEntry({
  shoppingCart, callbacks}) {

  const {errors = {}} = shoppingCart;
  const err = errors.couponCode;

  return <div className="text-sm xp-4">
    <FieldWithApply shoppingCart={shoppingCart} callbacks={callbacks}
      id="cart_coupon_code" name='couponCode' placeholder="Coupon Code"
    />
    {err && <div className="offer-not-available">{err}</div>}
  </div>;
}
